<template>
  <div>
    <div class="flex items-center justify-between mt-2">
      <page-header
        heading="Payments"
        breadcrumb="Settings  >>  Payments"
      />
  </div>
  <payments />
  </div>
</template>

<script>
import PageHeader from "@/components/Ondemand/PageHeader";
import Payments from "@/components/Ondemand/Payments/Payments.vue";

export default { 
  components: {
    PageHeader,
    Payments
  },
};  
</script>

<style></style>
